<template>
    <HeaderBar v-if="!appData.isMobile">
        <template #default></template>
        <template #rule>-</template>
    </HeaderBar>
    <HeaderBarMobile v-else>
        <slot></slot>
    </HeaderBarMobile>
</template>
<script>
    import HeaderBar from "@/layouts/_partials/HeaderBar.vue";
    import HeaderBarMobile from "@/layouts/_partials/HeaderBar.mobile.vue";

    export default {
        components: {
            HeaderBar,
            HeaderBarMobile,
        },
    };
</script>